import { render } from "./ModalCreate.vue?vue&type=template&id=5f3a6c64"
import script from "./ModalCreate.vue?vue&type=script&lang=js"
export * from "./ModalCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__